import * as React from 'react';

function Extended({data} :any) {
  return (
    <div className="col-lg-4 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title"></h4>
          <p></p>
          <div className="table-responsive">
            <table className="table table-striped">
              <tbody>
                <tr>
                  <td>Latest Volume</td>
                  <td>{data.latest_volume}</td>
                </tr>
                <tr>
                  <td>52 Week Low</td>
                  <td>{data.week_52_low}</td>
                </tr>
                <tr>
                  <td>52 Week High</td>
                  <td>{data.week_52_high}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Extended;
